var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "38-instagram") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "04-D---CDP",
    transform: "translate(-1116.000000, -7697.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "footer-updated",
    transform: "translate(0.000000, 7536.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Footer-DSK/V1",
    transform: "translate(0.000000, 60.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Social",
    transform: "translate(1116.000000, 42.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "38-instagram",
    transform: "translate(0.000000, 59.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,5.76 C8.5875,5.76 5.76,8.53875 5.76,12 C5.76,15.46125 8.53875,18.24 12,18.24 C15.46125,18.24 18.24,15.4125 18.24,12 C18.24,8.5875 15.4125,5.76 12,5.76 Z M12,15.9975 C9.80625,15.9975 8.0025,14.19375 8.0025,12 C8.0025,9.80625 9.80625,8.0025 12,8.0025 C14.19375,8.0025 15.9975,9.80625 15.9975,12 C15.9975,14.19375 14.19375,15.9975 12,15.9975 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 18.72,
    cy: 6.24,
    r: 1.44
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0645161,1.98387097 C20.8064516,0.677419355 19.016129,0 16.983871,0 L7.01612903,0 C2.80645161,0 0,2.80645161 0,7.01612903 L0,16.9354839 C0,19.016129 0.677419355,20.8064516 2.03225806,22.1129032 C3.33870968,23.3709677 5.08064516,24 7.06451613,24 L16.9354839,24 C19.016129,24 20.7580645,23.3225806 22.016129,22.1129032 C23.3225806,20.8548387 24,19.0645161 24,16.983871 L24,7.01612903 C24,4.98387097 23.3225806,3.24193548 22.0645161,1.98387097 Z M21.7741935,16.983871 C21.7741935,18.483871 21.3387097,19.6935484 20.4677419,20.516129 C19.5967742,21.3387097 18.3870968,21.7741935 16.9354839,21.7741935 L7.06451613,21.7741935 C5.61290323,21.7741935 4.40322581,21.3387097 3.53225806,20.516129 C2.66129032,19.6451613 2.22580645,18.4354839 2.22580645,16.9354839 L2.22580645,7.01612903 C2.22580645,5.56451613 2.66129032,4.35483871 3.53225806,3.48387097 C4.35483871,2.66129032 5.61290323,2.22580645 7.06451613,2.22580645 L17.0322581,2.22580645 C18.483871,2.22580645 19.6935484,2.66129032 20.5645161,3.53225806 C21.3870968,4.40322581 21.8709677,5.61290323 21.8709677,7.01612903 L21.8709677,16.983871 L21.7741935,16.983871 Z",
    id: "Shape"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.22fef567dc243d03830e91c9a81d896a.svg";
export { ForwardRef as ReactComponent };